import { PUT_FOUNDERS_START } from '../../types';

export const put_founders = (payload) => ({
  type: PUT_FOUNDERS_START,
  payload,
});
